import { render } from "./IndexJournees.vue?vue&type=template&id=40d4f2e1"
import script from "./IndexJournees.vue?vue&type=script&lang=js"
export * from "./IndexJournees.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__